<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group :label="$t('share.content.slack_form_message')">
        <b-form-textarea required
                         rows=3
                         v-model="form.message">
        </b-form-textarea>
      </b-form-group>
      <b-form-group :label="$t('share.content.slack_form_channels')">
        <b-form-select v-model="form.channel" :options="channelOptions" required></b-form-select>
      </b-form-group>
      <div class="icon-panel">
        <b-col class="text-right">
          <b-button type="submit" variant="primary">{{$t('share.content.slack_form_submit_btn')}}</b-button>
        </b-col>
      </div>
    </b-form>
  </div>
</template>

<script>
import {getSlackChannels} from '../../services/api.js'
export default {
  name: 'Slack',
  data() {
    return {
      form: {
        message: '',
        channel: ''
      },
      channelOptions: []
    }
  },
  methods: {
    onSubmit() {
      event.preventDefault()
      this.$emit('submit', this.form)
    }
  },
  created() {
    let options = JSON.parse(this.$cookie.get('s-channels-options'))
    if(!options) {
      let token = this.$cookie.get('s-token-slack')
      getSlackChannels(token)
        .then(result => {
          let data = result.data
          data.forEach((value) => {
            this.channelOptions.push({text: '#' + value.name, value: value.id})
          })
          this.$cookie.set('s-channels-options', JSON.stringify(this.channelOptions), {expires: '30m'})
          this.$emit('loaded')
        })
        .catch(error => {
          alert(error)
        })
    } else {
      this.channelOptions = options
      this.$emit('loaded')
    }
  }
}
</script>
